const NAZIVI_STANJA: Record<string, string> = {
  nedostaje_podatak: "Nedostaje podatak",
  istekao: "Isteklo",
  nevaljan: "Nevaljano",
};

export function nazivStanja(stanje: string): string {
  return NAZIVI_STANJA[stanje] ?? stanje;
}
